import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Switch from 'react-switch';
import Config from '../../Util/config';
import HttpUtil from '../../Util/httpUtil';
import { BlockUiContext } from '../../Providers/BlockUi';
import { withRouter } from 'react-router-dom';
import Pagination from '../../Util/Pagination';

import './SimularAcesso.scss';

const administrador = localStorage.getItem('Administrador') === 'true';
const vendas = localStorage.getItem('usuarioVendas') === 'true';

function SimularAcesso(props) {
	const [filtroCliente, setFiltroCliente] = useState('');
	const [filtroID, setFiltroID] = useState('');
	const [filtroUsuario, setFiltroUsuario] = useState('');
	const [buscarPRO, setBuscarPRO] = useState(vendas);
	const [showData, setShowData] = useState([]);
	const [pageData, setDataPage] = useState('');

	let onLoading;
	let inputFiltroCliente;
	const columns = [
		{
			Header: 'ID',
			className: 'text-center',
			accessor: 'CodUsuario',
		},
		{
			Header: 'Cliente',
			className: 'text-left',
			accessor: 'NomeUsuario',
		},
		{
			Header: () => (buscarPRO ? 'Token' : 'Usuário'),
			className: 'text-center',
			accessor: 'Login',
		},
		{
			Header: '',
			maxWidth: 50,
			className: 'text-center',
			// eslint-disable-next-line react/display-name
			Cell: row => <i className="ecoico fas fa-share text-info" onClick={() => simular(row.original)} />,
		},
	];
	useEffect(() => {
		if (!administrador) props.history.goBack();
		inputFiltroCliente.focus();
	}, []);

	const childPaginationValue = (page) => {
		setDataPage(page);
	}

	const buscarLista = () => {
		onLoading(true);
		let url = `${Config.urls.API_URL_BASE}Acesso/BuscarListaUsuarios?`;
		var parametros = filtroCliente === '' ? '' : 'nome=' + filtroCliente;
		parametros += filtroID === '' ? '' : (parametros ? '&' : '') + 'id=' + filtroID;
		parametros += filtroUsuario === '' ? '' : (parametros ? '&' : '') + 'codigo=' + filtroUsuario;
		parametros += buscarPRO === '' ? '' : (parametros ? '&' : '') + 'pro=' + buscarPRO;
		url += parametros;
		HttpUtil.eco_GET(url).then(response => {
			onLoading(false);
			setShowData(response.data);
		});
	};
	const filtrar = e => {
		e.preventDefault();
		buscarLista();
	};
	const simular = usuario => {
		onLoading(true);
		var codUsuario = usuario.CodUsuario;
		if (usuario.isPro) {
			codUsuario = `39000${usuario.Login}`;
		}
		var url = `${Config.urls.API_URL_BASE}Acesso/ValidarDadosLogin/${codUsuario}`;
		HttpUtil.eco_GET(url).then(
			response => {
				localStorage.setItem('CodUsuario_OLD', localStorage.getItem('CodUsuario'));
				localStorage.setItem('isSimulacao', true);
				localStorage.setItem('CodUsuario', codUsuario);
				localStorage.setItem('NomeUsuario', response.data.NomeUsuario);
				localStorage.setItem('Login', response.data.Login);
				localStorage.setItem('Email', response.data.Email);
				localStorage.setItem('NomePerfil', response.data.NomePerfil);
				localStorage.setItem('Administrador', response.data.Administrador);
				localStorage.setItem('TermoUso', response.data.TermoUso);
				localStorage.setItem('roles', JSON.stringify(response.data.Roles));
				localStorage.setItem('Hash', response.data.Hash);
				localStorage.setItem('isPro', response.data.isPro);
				localStorage.setItem('AccessToken', response.data.accessToken);
				localStorage.setItem('Token', '');
				window.location = '/pendentes';
				onLoading(false);
			},
			() => {
				window.location = '/erro';
				onLoading(false);
			},
		);
	};
	return (
		<main id="simularAcesso">
			<BlockUiContext.Consumer>
				{blockUi => {
					onLoading = blockUi.handleLoading;
				}}
			</BlockUiContext.Consumer>
			<Row noGutters id="main-header">
				<Col>
					<Row>
						<Col className="singleHeaderHeight p-0">
							<h1>Simular Acesso</h1>
							<hr />
						</Col>
					</Row>
					<section className="filtros">
						<form onSubmit={filtrar}>
							<Row className="justify-content-between">
								<Col xs={2}>
									<div className="form-group">
										<label className="control-label">ID</label>
										<input
											className="ecoforms form-control"
											type="text"
											onChange={({ target: { value } }) => {
												setFiltroID(value);
											}}
										/>
									</div>
								</Col>
								<Col xs={5}>
									<div className="form-group">
										<label className="control-label">Cliente</label>
										<input
											className="ecoforms form-control"
											type="text"
											ref={input => {
												inputFiltroCliente = input;
											}}
											onChange={({ target: { value } }) => {
												setFiltroCliente(value);
											}}
										/>
									</div>
								</Col>
								<Col xs={2}>
									<div className="form-group">
										<label className="control-label">{buscarPRO ? 'Token' : 'Usuário'}</label>
										<input
											className="ecoforms form-control"
											type="text"
											onChange={({ target: { value } }) => {
												setFiltroUsuario(value);
											}}
										/>
									</div>
								</Col>
								{!vendas && (
									<Col xs={1}>
										<div className="form-group">
											<label className="control-label">PRO</label>
											<Switch
												onChange={checked => {
													setBuscarPRO(checked);
													setShowData([]);
												}}
												className="react-switch"
												checked={buscarPRO}
												uncheckedIcon={false}
												checkedIcon={false}
											/>
										</div>
									</Col>
								)}
								<Col xs={2}>
									<button type="submit" className="btn btn-primary btnFiltrarClientes">
										Filtrar
									</button>
								</Col>
							</Row>
						</form>
					</section>
				</Col>
			</Row>
			<Row noGutters>
				<Col>
					<ReactTable
						data={showData}
						columns={columns}
						showPagination={showData.length > 0}
						PaginationComponent={Pagination}
						childPaginationValue={childPaginationValue}
						strTableInfo={buscarPRO ? 'Tokens' : 'Usuários'}
					/>
				</Col>
			</Row>
		</main>
	);
}
export default withRouter(SimularAcesso);
